<template>
<BaseDialog
	data-component="PromptDialog.vue"
	ref="dialog"
	:modelValue="modelValue"
	:historyMode="historyMode"
	:type="type"
	@update:model-value="$emit('update:modelValue', $event);"
	@dismissed="$emit('dismissed', $event)"
	@opened="$emit('opened')"
	@closed="$emit('closed')"
>
	<div class="flex flex-col gap-3 sm:text-base text-sm">
		<div v-if="title" class="text-xl font-bold" v-html="title"/>
		<div v-if="body" v-html="body"/>
		<slot/>
	</div>
	<div class="sm:flex-row-reverse sm:mb-0 w-max sm:w-full flex flex-col gap-2 mx-auto mt-6 mb-2">
		<button
			v-if="confirmText"
			data-test="prompt_dialog__confirm"
			class="btn btn-info btn-medium"
			@click.prevent="emitAction('confirmed', 'button')"
			v-html="confirmText"
		/>
		<button
			v-if="secondaryText"
			data-test="prompt_dialog__confirm_secondary"
			class="btn btn-outline-info btn-medium ml-0 sm:ml-auto"
			@click.prevent="emitAction('confirmed-secondary', 'button')"
			v-html="secondaryText"
		/>
		<button
			v-if="dismissText"
			data-test="prompt_dialog__dissmised"
			class="btn btn-medium text-info"
			:class="{'border border-solid border-info': isDismissButtonBorder }"
			@click.prevent="emitAction('dismissed', 'button')"
			v-html="dismissText"
		/>
	</div>
</BaseDialog>
</template>

<script lang="ts">
import BaseDialog from './BaseDialog.vue';
/*
	Okno dialogowe z pytaniem oraz przyciskami.
*/
export default {
	name: 'PromptDialog',
	components: {
		BaseDialog,
	},
	props: {
		/**
		 * Czy modal ma być wyświetlony?
		 */
		modelValue: {
			type: Boolean,
			default: false,
		},

		/**
		 * Zamiast aktualizować model przy wywołaniu akcji, wywołaj `window.history.back()`.
		 */
		historyMode: {
			type: Boolean,
			default: true,
		},

		/**
		 * Tytuł pytania
		 */
		title: {
			type: String,
			default: '',
		},

		/**
		 * Treść pytania
		 */
		body: {
			type: String,
			default: '',
		},

		/**
		 * Treść przycisku potwierdzającego
		 */
		confirmText: {
			type: String,
			default: 'OK',
		},

		/**
		 * Treść przycisku pomocniczego (jeżeli puste - nie wyświetlaj)
		 */
		secondaryText: {
			type: String,
			default: '',
		},

		/**
		 * Treść przycisku anulującego dialog (może mieć inne działanie
		 * niż inny sposób zamknięcia okna, poprzez sprawdzenie parametru akcji `@dimissed`)
		 */
		dismissText: {
			type: String,
			default: 'Anuluj',
		},

		/**
		 * Czy dismissButton ma mieć ramke?
		 */
		isDismissButtonBorder: {
			type: Boolean,
			default: false,
		},

		/**
		 * Typ okna dialogowego
		 */
		type: {
			type: String,
			default: 'default',
		},
	},
	emits: ['update:modelValue', 'dismissed', 'confirmed', 'confirmed-secondary', 'opened', 'closed'],
	methods: {
		/**
		 * Po kliknięciu przycisku wysyła odpowiednie zdarzenie (`confirmed`, `confirmed-secondary`, `dismissed`)
		 * @param name Typ przycisku
		 * @param source Źródło kliknięcia (przycisk, krzyżyk, nakładka)
		 */
		emitAction(name:'dismissed'|'confirmed'|'confirmed-secondary', source:'button'|'window'|'overlay' = 'button') {
			this.$emit(name, source);
			this.close();
		},

		/**
		 * Zamyka okno dialogowe: w zależności od właściwościwości `historyMode`, ustawia
		 */
		close() {
			(this.$refs.dialog as InstanceType<typeof BaseDialog>).close();
		},
	},
};
</script>
